<template>
    <div class="flex w-full">
        <div
            v-if="isLoading"
            class="spinner-container"
        >
            <SpinnerBars/>
        </div>
        <div
            v-else
            class="promotions__page"
            ref="promoContent"
        >
            <SanitizedHtml :content="content"/>
        </div>
    </div>
</template>

<script>
    import SanitizedHtml from '@modules/shared/components/SanitizedHtml.vue';
    import XJackpitMixin from './XJackpotMixin';

    const PROMOTION_CLASS = 'promotions__item';
    const XJACKPOT_IMAGE = 'x-jackpot-promo-box';

    export default {
        name: 'BonusesPromotions',
        mixins: [XJackpitMixin],
        props: {
            content: {
                type: String,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                xJackpotValue: 0,
                xJackpotIncrementPerSecond: 0,
            };
        },
        mounted() {
            this.setupCounter();
        },
        methods: {
            async findXJackpotElements() {
                await this.$nextTick();
                if (!this.$refs.promoContent) {
                    return null;
                }
                const promotions = this.$refs.promoContent.getElementsByClassName(PROMOTION_CLASS);
                return [Array.from(promotions).find((promotion) =>
                    promotion.querySelector('img')
                        .getAttribute('src')
                        .includes(XJACKPOT_IMAGE))];
            },
        },
        components: {
            SanitizedHtml,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/wiki/components/BonusesPromotions.vue